import domReady from '../js-lib/domReady'
import hookWrite from '../js-lib/hookWrite'
import { closest } from '../js-lib/domClosest'

const players = {}

domReady(() => {
	waitForJstream()
	initPlayButtons()
})

function waitForJstream () {
	let timer = setInterval(() => {
		if (window.jstream_t3 && window.jstream_t3.PlayerFactoryIF) {
			clearInterval(timer)

			// すぐに初期化すると失敗することがあるので余裕を持たせる
			setTimeout(initPlayers, 500)
		}
	}, 500)
}

function initPlayButtons () {
	const listener = event => {
		if (event.touches && event.touches.length !== 1) return
		const button = closest('.jstream-video-thumb-play', event.target)
		if (!button) return
		const id = button.getAttribute('data-play')
		if (!id || !players[id]) return
		players[id].setActive(true)
	}
	document.addEventListener('click', listener)
	// document.addEventListener('touchend', listener)
}

function initPlayers () {
	[].forEach.call(document.querySelectorAll('.jstream-video-container'), container => {
		const player = new Player(container)
		players[player.id] = player
	})
}

class Player {

	constructor (container) {
		const { id } = container
		if (!id) throw new Error('.jstream-video-container must have an id.')

		const inner = document.createElement('div')
		inner.className = 'jstream-video-inner'
		container.appendChild(inner)

		const options = JSON.parse(container.querySelector('.jstream-video-options').textContent)
		if (!options) throw new Error('.jstream-video-options is broken.')

		hookWrite(inner)
		const player = jstream_t3.PlayerFactoryIF.create(options)
		hookWrite(null)

		const close = document.createElement('div')
		close.className = 'jstream-video-close'
		close.textContent = 'Close'
		inner.appendChild(close)
		close.addEventListener('click', () => this.setActive(false))
		// close.addEventListener('touchstart', () => this.setActive(false))

		const backdrop = document.createElement('div')
		backdrop.className = 'jstream-video-backdrop'
		container.appendChild(backdrop)
		backdrop.addEventListener('click', () => this.setActive(false))
		// backdrop.addEventListener('touchstart', () => this.setActive(false))

		this.id = id
		this.container = container
		this.player = player
		this.active = false
	}

	setActive (active) {
		this.active = active
		if (active) {
			this.container.classList.add('active')
			setTimeout(() => this.container.classList.add('in'), 60)
		} else {
			this.player.accessor.pause()
			this.container.classList.remove('in')

			// 雑な実装
			setTimeout(() => {
				this.container.classList.remove('active')
			}, 750)
		}
	}
}
